import React from "react";
import { Card, Typography } from "antd";

const { Title, Text } = Typography;

interface JudgedPhotoProps {
  fileId: string | null;
  photoUrl?: string;
}

const JudgedPhoto: React.FC<JudgedPhotoProps> = ({ fileId, photoUrl }) => {
  if (!fileId) {
    return (
      <Card size="small">
        <Title level={5} style={{ marginTop: 0 }}>
          Foto evaluada por el modelo
        </Title>
        <Text type="secondary">
          Esta corrida no registró qué foto se evaluó.
        </Text>
      </Card>
    );
  }

  return (
    <Card size="small">
      <Title level={5} style={{ marginTop: 0 }}>
        Foto evaluada por el modelo
      </Title>
      {photoUrl ? (
        <img
          src={photoUrl}
          alt={`Foto evaluada por el modelo: ${fileId}`}
          style={{ maxWidth: 320, maxHeight: 320, display: "block" }}
        />
      ) : (
        <Text type="secondary">
          {`La foto evaluada (${fileId}) ya no está en esta actividad.`}
        </Text>
      )}
    </Card>
  );
};

export default JudgedPhoto;
